import {pickerDefaultType, pickerMinoType} from "../core/components/datePicker/interface";
import {LocaleInfoModel} from "../core/components/localization/interface";
import dayjs, {Dayjs} from "dayjs";
import {isString} from "lodash";
import LocaleInfo from "../core/localization/constants/LocaleInfo";
import {defaultLocale} from "../core/localization/defaults";

export const getFormatOptions =(picker:pickerMinoType,localeInfo?:LocaleInfoModel)=>{
    let result:string = '';
    let pickerType:pickerDefaultType = undefined;
    let showTime:boolean = false;
    let globalFormat:string = '';
    let sendFormat:string = '';

    switch (picker){
        case "date":
            result = localeInfo?.localeDateFormat ?? "DD/MM/YYYY";
            globalFormat='YYYY-MM-DD'
            pickerType = picker;
            sendFormat = "YYYY-MM-DD";
            break;
        case "datetime":
            result = localeInfo?.localeDateTimeFormat ??  "DD/MM/YYYY HH:mm:ss";
            showTime = true;
            pickerType = undefined;
            globalFormat='YYYY-MM-DD HH:mm:ss'
            sendFormat = "YYYY-MM-DDTHH:mm:ss";
            break;
        case  "time":
            result = localeInfo?.timeFormat ??  "HH:mm:ss";
            showTime = true;
            pickerType = picker;
            globalFormat='HH:mm:ss'
            sendFormat= 'LTS'
            break;
        case  "week":
            result = "MM/DD";
            pickerType = picker;
            globalFormat='YYYY-Www'
            sendFormat = "L LTS";
            break;
        case  "year":
            result = "YYYY";
            pickerType = picker;
            globalFormat='YYYY'
            sendFormat = "L";
            break;
        default:
            pickerType = "date";
            result = localeInfo?.localeDateFormat ?? "DD/MM/YYYY";
            globalFormat='YYYY-MM-DD HH:mm:ss'
            sendFormat = "L";
            break;
    }
    return{
        format:result,
        picker:pickerType,
        languageCode:localeInfo?.languageCode,
        showTime,
        globalFormat,
        sendFormat
    }
}
export  const getNow=()=>{
    return dayjs();
}
export const getDate=()=>{
    return getNow().set("hour", 0).set("minute",0).set("second",0).set("millisecond",0);
}
export  const getNowDateSubstractYear=(year:number)=>{
    return dayjs().subtract(year,"year");
}
export  const getNowDateSubstractYearToString=(year:number,picker:pickerMinoType)=>{
    return  getStringFromDate(dayjs().subtract(year,"year"),picker);
}
export  const getStringDateTime =(date:dayjs.Dayjs)=>{
    return getStringFromDate(date,"datetime");
}
    export  const getStringDate =(date:dayjs.Dayjs)=>{
    return getStringFromDate(date,"date");
}
export  const getStringFromDate =(date:dayjs.Dayjs,picker:pickerMinoType)=>{
    return date.format(getFormatOptions(picker,undefined).sendFormat).toString();
}

export const parseDateTimeFromString = (dateString:string,picker:pickerMinoType,localeInfo?:LocaleInfoModel)=>{

    return parseDayjsFromString(dateString,picker,localeInfo)?.toDate();

}
export const dateFormat = {
    date: 'YYYY-MM-DD',
    dateTime: 'YYYY-MM-DDTHH:mm:ss',
    time: 'HH:mm'
}
export const parseDayjsFromString = (dateString:string, picker:pickerMinoType, localeInfo?:LocaleInfoModel)=>{

    let resultDate:Dayjs|undefined = undefined;
    if(isString(dateString)){
        const formatOptions = getFormatOptions(picker,localeInfo);
        const dateLocale = localeInfo ?? detectLanguageCodeByDateTime(dateString);
        const  languageCode = dateLocale.languageCode;
        if((dateString as unknown as string).indexOf("T") > 0){
            resultDate = dayjs(dateString, dateFormat.dateTime).locale(languageCode);
            if(!resultDate.isValid()){
                resultDate = dayjs(dateString, formatOptions.format).locale(languageCode);
            }
        }else{
            const regex = /(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d/;
            const formatType = regex.test(dateString) ? dateLocale.localeDateTimeFormat : dateFormat.date;
            resultDate = dayjs(dateString, formatType).locale(languageCode);
            if(!resultDate.isValid()){
                resultDate = dayjs(dateString, formatOptions.format).locale(languageCode);
            }
        }
    }
    return resultDate;

}

export function detectLanguageCodeByDateTime(input: string): LocaleInfoModel {
    const patterns: { locale: string; regex: RegExp }[] = [
        {
            locale: 'tr-TR',
            regex: /\b\d{2}\.\d{2}\.\d{4} (?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d\b/
        },
        {
            locale: 'az-Latn-AZ',
            regex: /\b\d{2}\.\d{2}\.\d{4} (?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d\b/
        },
        {
            locale: 'uz-Latn-UZ',
            regex: /\b\d{2}\.\d{2}\.\d{4} (?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d\b/
        },
        {
            locale: 'en-US',
            regex: /\b\d{4}-\d{2}-\d{2} (?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d\b/
        },
        {
            locale: 'ru-RU',
            regex: /\b\d{2}\.\d{2}\.\d{4} (?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d\b/
        },
        {
            locale: 'ar-QA',
            regex: /\b\d{2}\/\d{2}\/\d{4} (?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d\b/
        }
    ];

    for (const pattern of patterns) {
        if (pattern.regex.test(input)) {
            const match = LocaleInfo.find(l => l.locale === pattern.locale);
            return match ? match :defaultLocale;
        }
    }

    return defaultLocale; // Hiçbiri uyuşmazsa default
}